import { env } from "@/constants/env";
import { Typography } from "@backpac/monica";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

export function OauthCallbackPaypalPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  const code = searchParams.get("code");
  const state = searchParams.get("state");

  useEffect(() => {
    if (!code || !state) {
      setError("Missing required parameters");
      return;
    }

    const handlePaypalCallback = async () => {
      const { workspaceId, returnUrl } = JSON.parse(state);

      try {
        await fetch(`${env.API_BASE}/api/v1/workspaces/${workspaceId}/payout/paypal/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            code,
            redirectUri: returnUrl,
          }),
        });

        window.close();
      } catch (error) {
        console.error(error);
        setError(error instanceof Error ? error.message : "An unknown error occurred");
      }
    };
    handlePaypalCallback();
  }, [code, state]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {error ? (
        <div className="text-center">
          <Typography size="lg" color="textPrimary" weight={600}>
            {error}
          </Typography>
          <div className="mt-4">
            <button
              type="button"
              className="px-4 py-2 bg-primary text-white rounded"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
          </div>
        </div>
      ) : (
        <div className="text-center">
          <Typography size="lg" weight={600}>
            Connecting with PayPal...
          </Typography>
          <div className="mt-4">
            <div className="animate-spin h-10 w-10 border-4 border-primary border-t-transparent rounded-full mx-auto" />
          </div>
        </div>
      )}
    </div>
  );
}
